export const modeToText = mode => {
  switch (mode) {
    case 'equals':
      return 'برابر هست';
    case 'notequals':
      return 'برابر نیست';
    case 'lessthan':
      return 'کمتر از';
    case 'lessthanorequals':
      return 'کمتر یا مساوی';
    case 'greaterthan':
      return 'بزرگتر از';
    case 'greaterthanorequals':
      return 'بزرگتر یا مساوی';
    case 'inrange':
      return 'درمحدوده';
    case 'notblank':
      return 'خالی نباشه';
    case 'contains':
      return 'شامل باشه';
    case 'notcontains':
      return 'شامل نباشه';
    case 'startswith':
      return 'شروع با';
    case 'endswith':
      return 'پایان با';
    case 'blank':
      return 'خالی باشه';
  }
};
export const checkModeToText = mode => {
  switch (mode) {
    case 'and':
      return 'و';
    case 'or':
      return 'یا';
  }
};
